import React from 'react';
import PageTitle from '../PageTitle';
import { doRequest } from '../../helper';
import { constants } from '../../Bootstrap';

import $ from 'jquery';

export default class UserListing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: {},
            response: null,
            limit: 500,
            page: 1,
            currentPage: 1,
            searchText: '',
            issearch: false,
            random: 0,
            filter:'',
            totalCount:0,
        }
        this.getPosts = this.getPosts.bind(this);
        this.setCurrentPage = this.setCurrentPage.bind(this);
        this.search = this.search.bind(this);
        this.clear = this.clear.bind(this);
        this.filterBy=this.filterBy.bind(this);

    }
    componentDidMount() {
        var status = this.props.match.params.status;
        if (!status) {
            status = "enabled";
        }
        this.getPosts(status);
    }
    componentWillReceiveProps(nextProps) {
        var status = nextProps.match.params.status;
        if (!status) {
            status = "enabled";
        }
        this.getPosts(status);
    }

    getPosts(status, lastkey) {
        $("#loader").css({'display':'block'});
        $("#total_count").css({"display":"none"});
        $("#pagination_listing").css({"display":"none"});
        if (!status) {
            status = "enabled";
        }
        var ref = this;
        //    ref.checkPendingRequest()
        var items = this.state.items;
        var page = this.state.page;
        let count = this.state.totalCount;
        var payload = {
            'action': 'list-user',
            'module': 'Sampark',
            'model': 'Infographic',
            'data': {
                'direction': 'desc',
                'status': status,
                'limit': ref.state.limit
            }
        }
        if (lastkey) {
            payload['data']['lastkey'] = lastkey;
        }
        var request = doRequest('cms-operations', payload, true)

        request.addEventListener("load", function () {
            var response = this.responseText;
            try {
                response = JSON.parse(response);
                if (response._resultflag && response._resultflag == 1) {
                    items[page++] = response.items;
                    ref.setState({ "page": page, "response": response, "items": items, "lastIndex": response.lastEvaluatedKey });
                                   
                    if (response.lastEvaluatedKey) {
                        if(response.items.length){
                            count=count+response.items.length
                            ref.setState({
                                "totalCount":count
                            })
                        } 
                                         
                        ref.getPosts(status, response.lastEvaluatedKey)
                        ref.searchText.value = "Please Wait.....";
                        $('#finduser').prop('disabled', true);
                        $("#loader").css({'display':'none'});
                    
                    } else {
                        $('#finduser').prop('disabled', false);
                        ref.searchText.value = "";
                      $("#total_count").css({"display":"block"});
                      $("#pagination_listing").css({"display":"block"});
                      
                        
                    }
                }
            } catch (ex) {

            }

        });
    }

    setCurrentPage(e) {

        this.setState({ currentPage: e.target.innerText});
        $("#page_num_"+e.target.innerText).addClass('disable');
    }
    clear() {      
        var ref = this;
        ref.searchText.value = "";
        ref.setState({"items": {},
        "response": null,
        "limit": 100,
        "page": 1,
        "currentPage": 1,
        "searchText": '',
        "issearch": false,
        "random":0,
        "filter":'Select'
        ,"totalCount":0 },()=>{
            ref.filter.value="Select"; 
            ref.getPosts();
        });

//window.location.reload();
    }
    filterBy(){
        this.setState({ filter: this.filter.value });
      //  alert(this.filter.value)
    }

    search(text) {
        var ref = this;
        var items;
        var page = 0;
        var payload = {
            'action': 'list-user',
            'module': 'Sampark',
            'model': 'Infographic',
            'data': {
                'direction': 'desc',
                'status': 'enable',
                'limit': ref.state.limit,          
            }
        }
        if (ref.state.filter=="Name") {
            payload['data']['name'] = text;
        }
        else if(ref.state.filter=="Sampark Point"){
            payload['data']['point'] = text;
        }

        var request = doRequest('cms-operations', payload, true)

        request.addEventListener("load", function () {
            var response = this.responseText;
            try {
                response = JSON.parse(response);
                if (response._resultflag && response._resultflag == 1) {
                    console.log(response.items);
                    items = response.items
                    console.log(response.items);
                    ref.setState({ "page": page, "response": response, "items": response.items, "issearch": true, "lastIndex": response.lastEvaluatedKey, currentPage: 1 });

                }
            } catch (ex) {

            }

        });
    }
    render() {
        var response = this.state.response;      
        var items = this.state.items;
     var pages = [];

        for (var i = 1; i < this.state.page; i++) {
            pages.push( <li className="page-item" value={i} onClick={(e)=>this.setCurrentPage(e)} ref={(currentPage) => { this.currentPage = currentPage }}><a className={this.state.currentPage == i ? "page-link page_active" : "page-link"} id={"page_num_"+i} >{i}</a></li>)
        }

        return (
            <div>
                <PageTitle title="Sampark Abhiyan" bread="Sampark Abhiyan / User Listing" />
                <div className="wrapper wrapper-content">
                    <div className="wrapper wrapper-content">
                        <div className="ibox">
                            <div className="ibox-content">
                                <div className="form-inline">
                                    <div className="form-group col-sm-3">
                                        <label htmlFor="">Sort By : </label>
                                        <select className="form-control" onChange={this.filterBy} ref={(filter) => {this.filter = filter }}>
                                        <option>Select</option>
                                        <option>Name</option>
                                        <option>Sampark Point</option></select>
                                    </div>

                                    <div className="col-sm-3" id="total_count" >
                                        <h3>Total User : <span>{ this.state.totalCount ? this.state.totalCount : '' }</span></h3>
                                    </div>

                                    <div className="input-group col-sm-4 pull-right">
                                        <input type="text" className="form-control" id="searchText" name="searchText" ref={(searchText) => { this.searchText = searchText }} />
                                        <span className="input-group-btn">
                                            <button id="finduser" name="finduser" ref={(finduser) => { this.finduser = finduser }} className="btn btn-primary btn-small" onClick={() => this.search(this.searchText.value)}>Search</button>
                                            <button onClick={this.clear} className="btn btn-danger"><i className="fa fa-times"></i> Clear</button>
                                        </span>
                                    </div>

                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table className="table table-striped table-condensed table-fixed"  >
                                        <thead>
                                            <tr>
                                                <th className="col-sm-2">User Name</th>
                                                <th className="col-sm-2">Email</th>
                                                <th className="col-sm-1">Sampark Point</th>
                                                <th className="col-sm-2">State</th>
                                                <th className="col-sm-1">City</th>
                                                <th className="col-sm-2">District</th>                                                
                                                <th className="col-sm-2">Booth Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>


                                            {items[this.state.currentPage] && this.state.issearch == false ? items[this.state.currentPage].map((value, index) => {
                                                return (
                                                    <tr>

                                                        <td className="col-sm-2">{value.user_name_display}</td>
                                                        <td className="col-sm-2 smprk_table_break_word">{value.user_email}</td>
                                                        <td className="col-sm-1">{value.sampark_point}</td>
                                                        <td className="col-sm-2">{value.state_name}</td>
                                                        <td className="col-sm-1 smprk_table_break_word">{value.city_name}</td>
                                                        <td className="col-sm-2">{value.district_name}</td>                                                     
                                                        <td className="col-sm-2">{value.booth_name}</td>
                                                    </tr>)
                                            }) : Array.isArray(items) && items.length > 0 && this.state.issearch == true ? items.map((value, key) => {
                                                return (
                                                    <tr>
                                                        <td className="col-sm-2">{value.user_name_display}</td>
                                                        <td className="col-sm-2 smprk_table_break_word">{value.user_email}</td>
                                                        <td className="col-sm-1">{value.sampark_point}</td>
                                                        <td className="col-sm-2">{value.state_name}</td>
                                                        <td className="col-sm-1 smprk_table_break_word">{value.city_name}</td>
                                                        <td className="col-sm-2">{value.district_name}</td>                                                     
                                                        <td className="col-sm-2">{value.booth_name}</td>
                                                    </tr>)
                                            }) : ""}
                                        </tbody>

                                    </table>

                                    <nav aria-label="..." id="pagination_listing">
                                        <ul className="pagination pagination-sm">   
                                        {pages}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/Components/Sampark/UserListing.jsx